var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.301,
    height: 17.305,
    viewBox: "0 0 17.301 17.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M21.6,20.546l-4.812-4.857a6.857,6.857,0,1,0-1.041,1.054l4.78,4.825a.74.74,0,0,0,1.045.027A.745.745,0,0,0,21.6,20.546ZM11.4,16.8a5.415,5.415,0,1,1,3.83-1.586A5.381,5.381,0,0,1,11.4,16.8Z",
    transform: "translate(-4.5 -4.493)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.2a9f6ea39bb77049459c03f9c67a4753.svg";
export { ForwardRef as ReactComponent };